<template>
  <div>
    <router-view name="hero" v-if="isAVRMobile"></router-view>
    <router-view v-if="$route.params.country" name="usForm"></router-view>
    <router-view v-else></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped></style>
